<template>
  <!-- 190709 sliding-task 클라스 추가 -->
  <div class="sliding-task">
    <div class="title-bar title-h4">작업정보 확인</div>
    <!-- 0326 sys-font 추가 -->
    <div class="list form-list sys-font">
      <el-form :model="formDatas" label-width="120px" label-position="left" v-if="!isDelWork">
        <el-form-item label="작업 구분"> {{ getWorkTypeFormatter(formDatas.workTypeId) }}</el-form-item>
        <el-form-item label="작업명">{{ getValueAfterCheckEmpty(formDatas.workName) }}</el-form-item>
        <el-form-item label="작업내용">{{ getValueAfterCheckEmpty(formDatas.workContents) }}</el-form-item>
        <el-form-item label="작업상태">{{ getWorkStatusLabel(workLastStatus) }}</el-form-item>
        <el-form-item label="공지여부">{{ getNotifyCheckEmpty(formDatas) }}</el-form-item>
        <el-form-item label="영향도">{{ getImpactFormatter(formDatas) }}</el-form-item>
        <el-form-item label="작업담당자">
          {{ getManagerFormatter(managerList) }}
          <el-tooltip v-if="managerList.length > 1" effect="dark">
            <i class="el-icon-info"></i>
            <div v-html="getTooltipManager(managerList)" slot="content"></div>
          </el-tooltip>
        </el-form-item>
        <el-form-item label="작업대상 장비">
          {{ getObjNameFormatter(objList) }}
          <el-tooltip v-if="objList.length > 1" effect="dark">
            <i class="el-icon-info"></i>
            <div v-html="getTooltipObjName(objList)" slot="content"></div>
          </el-tooltip>
        </el-form-item>
        <el-form-item label="작업시간">{{ getValueAfterCheckEmpty(formDatas.scheduleDetail) }}</el-form-item>
      </el-form>
      <el-form :model="formDatas" label-width="120px" label-position="left" v-else>
        <el-form-item label="작업상태">삭제된 작업 입니다.</el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { isEmpty, isNil } from 'lodash';
import { getValueAfterCheckEmpty, EMPTY_TEXT } from '@/utils/string';
import workManageAPI from '@/api/work/work';

export default {
  name: 'WWorkExtendPage',
  props: {
    workLastStatus: {
      type: String,
    },
    isDelWork: {
      type: Boolean,
    },
    formDatas: Object, // workTypeId, workName, workContents, scheduleDetail, noticeSeqNumber, objCount, workSeqNumber
    default: {},
  },
  data() {
    return {
      managerList: [],
      objList: [],
    };
  },
  watch: {
    formDatas: {
      deep: true,
      immediate: true,
      handler(value) {
        if (!isNil(value)) {
          if (!isNil(value.managerList)) {
            this.managerList = value.managerList;
          }
          if (!isNil(value.objList)) {
            this.objList = value.objList;
          }
          if (!isNil(value.workSeqNumber)) {
            this.loadStore();
          }
        }
      },
    },
  },
  methods: {
    /**
     * 데이터 빈값 확인
     * @author Yang
     */
    getValueAfterCheckEmpty(value) {
      return getValueAfterCheckEmpty(value);
    },
    /**
     * [getDeviceCountCheckEmpty 작업대상 장비 출력]
     * @author {Yang}
     */
    getDeviceCountCheckEmpty(row) {
      return getValueAfterCheckEmpty(row.objCount) === EMPTY_TEXT ? `${row.objName}` : `${row.objName} 외 ${row.objCount - 1} 건`;
    },
    /**
     * [getNotifyCheckEmpty 공지여부 출력]
     * @author {Yang}
     */
    getNotifyCheckEmpty(row) {
      return getValueAfterCheckEmpty(row.noticeSeqNumber) === EMPTY_TEXT && !(row.isNotice) ? '미공지' : '공지';
    },
    getWorkStatusLabel(value) {
      if (value === 'P') {
        return '처리중';
      } else if (value === 'S') {
        return '작업완료 (성공)';
      } else if (value === 'F') {
        return '작업완료 (실패)';
      }
      return '작업등록';
    },
    /**
     * [getWorkTypeAndStatusFormatter 작업구분 포맷터]
     * @author {Yang}
     */
    getWorkTypeFormatter(value) {
      switch (value) {
        case 'CHANGE': return '변경 작업';
        case 'CHECK': return '점검 작업';
        case 'CONSTRUCT': return '공사 작업';
        default: return EMPTY_TEXT;
      }
    },
    /**
     * [getWorkTypeAndStatusFormatter 영향도 포맷터]
     * @author {Yang}
     */
    getImpactFormatter(row) {
      switch (row.workImpact) {
        case 'GRADE_A': return '매우 높음';
        case 'GRADE_B': return '높음';
        case 'GRADE_C': return '중간';
        case 'GRADE_D': return '낮음';
        default: return '영향도 없음';
      }
    },
    loadStore() {
      if (isEmpty(this.formDatas)) {
        return;
      }
      if (isNil(this.formDatas.workSeqNumber)) {
        return;
      }
      workManageAPI.getWorkDetailsList({ workSeqNumber: this.formDatas.workSeqNumber })
        .then((result) => {
          const resultData = result.data;
          if (resultData.success === true) {
            this.objList = resultData.data.objList;
            this.managerList = resultData.data.managerList;
            this.$emit('add-details-info', resultData.data);
          }
        });
    },
    /**
     * [getManagerFormatter 작업 담당자 포맷]
     * @author {Yang}
     */
    getManagerFormatter(row) {
      if (isEmpty(row)) {
        return EMPTY_TEXT;
      }
      let manager = row[0].managerName;
      if (!isNil(row[0].mobileNumber)) {
        manager += `(${row[0].mobileNumber})`;
      }
      if (row.length > 1) {
        manager += ` 외 ${row.length - 1} 건`;
      }
      return manager;
    },
    /**
     * [getTooltipManager 작업 담당자 툴팁]
     * @author {Yang}
     */
    getTooltipManager(row) {
      if (isEmpty(row)) {
        return EMPTY_TEXT;
      }
      let manager = '<ul>';
      for (let i = 1; i < row.length; i += 1) {
        const li = `<li>${row[i].managerName}</li>`;
        manager += li;
      }
      return `${manager}</ul>`;
    },
    /**
     * [getObjNameFormatter 작업대상 장비]
     * @author {Yang}
     */
    getObjNameFormatter(row) {
      if (isEmpty(row)) {
        return EMPTY_TEXT;
      }
      if (row.length > 1) {
        return `${row[0].objName} 외 ${row.length - 1} 대`;
      }
      return row[0].objName;
    },
    getTooltipObjName(row) {
      if (isEmpty(row)) {
        return EMPTY_TEXT;
      }
      let objName = '<ul>';
      for (let i = 1; i < row.length; i += 1) {
        const li = `<li>${row[i].objName}</li>`;
        objName += li;
      }
      return `${objName}</ul>`;
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/performance/root/components/popup/components/WorkExtendPage.vue